import $ from 'jquery';
import ApexCharts from 'apexcharts';

$(function () {
    const $container = $('#compound-calculator-app');
    if (!$container.length) return;

    let currency = $container.data('currency') || 'UAH';
    let symbol = currency === 'USD' ? '$' : currency === 'EUR' ? '€' : currency === 'PLN' ? 'zł' : '₴';
    let chartInstance = null;

    const textMoreCurrencies = $container.data('text-more-currencies') || 'Ще валюти';
    const textMoreShort = $container.data('text-more-short') || 'Ще';

    const $initBtn = $('#compound-currency-tabs button.active');
    if ($initBtn.length) {
        currency = $initBtn.data('currency-code') || currency;
        symbol = $initBtn.data('symbol') || symbol;
    }

    const unitYears = $container.data('unit-years') || 'р.';
    const unitPerMonth = $container.data('unit-per-month') || '/ міс';
    const seriesPrincipal = $container.data('series-principal') || 'Власні внески';
    const seriesInterest = $container.data('series-interest') || 'Зароблені відсотки';

    const $initialRange = $('#compound-initial-range');
    const $initialDisplay = $('#compound-initial-display');

    const $monthlyRange = $('#compound-monthly-range');
    const $monthlyDisplay = $('#compound-monthly-display');

    const $rateRange = $('#compound-rate-range');
    const $rateDisplay = $('#compound-rate-display');

    const $yearsRange = $('#compound-years-range');
    const $yearsDisplay = $('#compound-years-display');

    function formatMoney(num) {
        return Math.round(num).toLocaleString('uk-UA') + ' ' + symbol;
    }

    function calculate() {
        const P = parseFloat($initialRange.val()) || 0;
        const PMT = parseFloat($monthlyRange.val()) || 0;
        const annualRate = (parseFloat($rateRange.val()) || 0) / 100;
        const years = parseInt($yearsRange.val(), 10) || 1;
        const n = 12; // monthly compounding

        $initialDisplay.text(formatMoney(P));
        $monthlyDisplay.text(formatMoney(PMT) + ' ' + unitPerMonth);
        $rateDisplay.text((annualRate * 100).toFixed(1) + '%');
        $yearsDisplay.text(years + ' ' + unitYears);

        const yearsLabels = [];
        const principalSeries = [];
        const interestSeries = [];

        let currentBalance = P;
        let totalPrincipal = P;

        for (let y = 1; y <= years; y++) {
            yearsLabels.push(y + ' ' + unitYears);
            for (let m = 1; m <= 12; m++) {
                currentBalance = (currentBalance + PMT) * (1 + annualRate / 12);
                totalPrincipal += PMT;
            }
            const earnedInterest = Math.max(0, currentBalance - totalPrincipal);
            principalSeries.push(Math.round(totalPrincipal));
            interestSeries.push(Math.round(earnedInterest));
        }

        const finalTotal = Math.round(currentBalance);
        const finalPrincipal = Math.round(totalPrincipal);
        const finalInterest = Math.max(0, finalTotal - finalPrincipal);
        const multiplier = finalPrincipal > 0 ? (finalTotal / finalPrincipal).toFixed(1) + 'x' : '1.0x';

        $('#compound-kpi-total').text(formatMoney(finalTotal));
        $('#compound-kpi-principal').text(formatMoney(finalPrincipal));
        $('#compound-kpi-interest').text(formatMoney(finalInterest));
        $('#compound-kpi-multiplier').text(multiplier);

        renderChart(yearsLabels, principalSeries, interestSeries);
    }

    function renderChart(labels, principalData, interestData) {
        const isDark = $('body').hasClass('dark') || $('body').attr('data-layout-mode') === 'dark';

        const options = {
            series: [
                { name: seriesPrincipal, data: principalData },
                { name: seriesInterest, data: interestData }
            ],
            chart: {
                type: 'area',
                height: 280,
                stacked: true,
                toolbar: { show: false },
                animations: { enabled: true, speed: 400 }
            },
            colors: ['#556ee6', '#34c38f'],
            fill: {
                type: 'gradient',
                gradient: {
                    opacityFrom: 0.75,
                    opacityTo: 0.25
                }
            },
            dataLabels: { enabled: false },
            stroke: { curve: 'smooth', width: 2 },
            xaxis: {
                categories: labels,
                labels: {
                    style: { colors: isDark ? '#a6b0cf' : '#74788d' }
                }
            },
            yaxis: {
                labels: {
                    formatter: function (val) {
                        if (val >= 1000000) return (val / 1000000).toFixed(1) + 'M ' + symbol;
                        if (val >= 1000) return Math.round(val / 1000) + 'K ' + symbol;
                        return Math.round(val) + ' ' + symbol;
                    },
                    style: { colors: isDark ? '#a6b0cf' : '#74788d' }
                }
            },
            tooltip: {
                theme: isDark ? 'dark' : 'light',
                y: {
                    formatter: function (val) {
                        return formatMoney(val);
                    }
                }
            },
            legend: {
                position: 'top',
                horizontalAlign: 'right',
                labels: { colors: isDark ? '#a6b0cf' : '#74788d' }
            },
            grid: {
                borderColor: isDark ? '#32394e' : '#f1f1f1'
            }
        };

        const chartEl = document.querySelector('#compound-growth-chart');
        if (!chartEl) return;

        if (chartInstance) {
            chartInstance.updateOptions(options);
        } else {
            chartInstance = new ApexCharts(chartEl, options);
            chartInstance.render();
        }
    }

    // Event Listeners for Sliders
    $initialRange.on('input', calculate);
    $monthlyRange.on('input', calculate);
    $rateRange.on('input', calculate);
    $yearsRange.on('input', calculate);

    // Quick Monthly Chips
    $(document).on('click', '.chip-monthly', function () {
        $('.chip-monthly').removeClass('active');
        $(this).addClass('active');
        const val = parseFloat($(this).data('value'));
        if (!isNaN(val)) {
            $monthlyRange.val(val);
            calculate();
        }
    });

    // Currency Switcher
    function setCompoundCurrency(btn, isDropdown) {
        currency = $(btn).data('currency-code');
        symbol = $(btn).data('symbol') || '$';

        if (isDropdown) {
            $('#compound-currency-tabs > button[data-currency-code]').removeClass('active');
            $('.compound-currency-dropdown-item').removeClass('active');
            $(btn).addClass('active');
            $('.compound-more-currencies-btn').addClass('active');
            $('#compound-active-custom-currency').text(`${symbol} ${currency}`);
        } else {
            $('#compound-currency-tabs button').removeClass('active');
            $(btn).addClass('active');
            $('.compound-more-currencies-btn').removeClass('active');
            $('.compound-currency-dropdown-item').removeClass('active');
            $('#compound-active-custom-currency').html(`
                <span class="d-none d-sm-inline">${textMoreCurrencies}</span>
                <span class="d-sm-none">${textMoreShort}</span>
            `);
        }

        const defInitial = parseFloat($(btn).data('default-initial')) || 50000;
        const defMonthly = parseFloat($(btn).data('default-monthly')) || 5000;
        const defRate = parseFloat($(btn).data('default-rate')) || 12.0;

        $initialRange.val(defInitial);
        $monthlyRange.val(defMonthly);
        $rateRange.val(defRate);

        // Adjust range max based on currency
        if (currency === 'USD' || currency === 'EUR' || currency === 'GBP' || currency === 'CHF' || currency === 'CAD') {
            $initialRange.attr({ max: 200000, step: 1000 });
            $monthlyRange.attr({ max: 10000, step: 50 });
        } else if (currency === 'PLN') {
            $initialRange.attr({ max: 500000, step: 2500 });
            $monthlyRange.attr({ max: 30000, step: 200 });
        } else {
            $initialRange.attr({ max: 2000000, step: 5000 });
            $monthlyRange.attr({ max: 100000, step: 500 });
        }

        // Render chips
        const chips = $(btn).data('chips');
        if (Array.isArray(chips)) {
            const $chipsContainer = $('#compound-monthly-chips').empty();
            chips.forEach(c => {
                const isAct = c === defMonthly ? 'active' : '';
                $chipsContainer.append(`<button type="button" class="btn btn-xs btn-soft-secondary chip-monthly ${isAct}" data-value="${c}">+${c.toLocaleString('uk-UA')}</button>`);
            });
        }

        calculate();
    }

    $('#compound-currency-tabs > button[data-currency-code]').on('click', function () {
        setCompoundCurrency(this, false);
    });

    $(document).on('click', '.compound-currency-dropdown-item', function (e) {
        e.preventDefault();
        setCompoundCurrency(this, true);
    });

    calculate();
});

